const total = items => {
  return items.reduce((acc, item) => {
    acc[item.moneda] = (acc?.[item.moneda] || 0) + Number(item.precio);
    return acc;
  }, {});
};

export default total;
